import PrintersOutOfPaperModal from './printers-out-of-paper-modal.connect'

export default PrintersOutOfPaperModal
